import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

const options = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => {
			return (
				<p className="typography typography--body-big why-cc__paragraph">
					{children}
				</p>
			);
		},
	},
};

const WhyCovidClinic = ({ image, title, description, cta, imageAlignment, variant }) => {
	return (
		<div
			className={`section why-cc ${variant === 'With Background' ? 'with-bg' : ''}`}
		>
			<div
				className={`section__content why-cc__content ${
					imageAlignment === 'right side' ? 'right-alignment' : 'left-alignment'
				}`}
			>
				<div className="why-cc__image-wrapper">
					<img
						alt={image?.description}
						className="why-cc__image"
						src={image?.file?.url}
					/>
				</div>
				<div className="why-cc__body">
					<h2 className="typography typography--h2 typography--secondary why-cc__title">
						{title}
					</h2>
					<div>{renderRichText(description, options)}</div>
					{cta && (
						<Link
							className="btn bg--transparent btn--outlined"
							to={cta?.link}
						>
							{cta?.title}
						</Link>
					)}
				</div>
			</div>
		</div>
	);
};

WhyCovidClinic.propTypes = {
	image: PropTypes.shape({
		gatsbyImageData: PropTypes.object,
		description: PropTypes.string,
		file: PropTypes.object,
	}),
	title: PropTypes.string.isRequired,
	description: PropTypes.shape({
		raw: PropTypes.string,
	}),
	cta: PropTypes.shape({
		link: PropTypes.string,
		title: PropTypes.string,
	}),
	imageAlignment: PropTypes.string.isRequired,
	variant: PropTypes.string.isRequired,
};

export default WhyCovidClinic;
